import React from 'react';
import LegalLayout, { LegalSection } from '../components/layout/LegalLayout';

export default function PrivacyPage() {
  return (
    <LegalLayout title="Politique de Confidentialité" lastUpdated="Janvier 2025">
      <p className="italic text-linx_text-muted">
        La présente Politique de Confidentialité explique comment AGODEV SOLUTIONS SARL (produit LinxExpress) collecte, utilise, conserve et protège les données personnelles dans le cadre des services LinxExpress en Tunisie.
      </p>

      <LegalSection title="Informations que Nous Collectons">
        <p>Nous collectons les données nécessaires à la création des comptes, à l'exploitation du service, à la sécurité et à la conformité légale, notamment :</p>
        <ul className="list-disc pl-6 space-y-1.5 mt-2">
          <li>Données client : nom complet, numéro de téléphone et adresse e-mail</li>
          <li>Données chauffeur : nom complet, numéro de téléphone, e-mail, adresse, CIN, permis de conduire, carte grise et photos du véhicule</li>
          <li>Données opérationnelles : détails des courses, données de géolocalisation/itinéraire, horodatages et interactions de service</li>
          <li>Données de communication : contenus de chat in-app et enregistrements des appels vocaux à des fins de sécurité et de prévention de fraude</li>
          <li>Données techniques : logs appareil/application, IP et événements de sécurité le cas échéant</li>
        </ul>
      </LegalSection>

      <LegalSection title="Comment Nous Utilisons Vos Informations">
        <p>Nous traitons les données personnelles sur les bases de nécessité contractuelle, d'intérêt légitime, d'obligation légale et, lorsque requis, de consentement, notamment :</p>
        <ul className="list-disc pl-6 space-y-1.5 mt-2">
          <li>Créer et gérer les comptes utilisateurs</li>
          <li>Mettre en relation les clients avec des transporteurs indépendants</li>
          <li>Calculer le prix unifié des courses selon la formule de l'application</li>
          <li>Opérer les contrôles de sécurité, les vérifications anti-fraude et l'examen des litiges</li>
          <li>Assurer le support, les réponses juridiques et la coopération réglementaire en cas d'obligation</li>
        </ul>
      </LegalSection>

      <LegalSection title="Partage d'Informations">
        <p>Nous ne vendons pas de données personnelles brutes. Nous ne partageons les données personnelles que dans la mesure nécessaire aux finalités opérationnelles et légales :</p>
        <ul className="list-disc pl-6 space-y-1.5 mt-2">
          <li>Les prestataires de paiement/recharge et opérations revendeurs (dont Flouci)</li>
          <li>Les prestataires d'infrastructure et services tiers (Firebase, OneSignal, Cloudinary, AWS, Agora, Google Maps)</li>
          <li>Les autorités publiques lorsqu'une obligation légale l'impose</li>
          <li>Des partenaires recevant des statistiques agrégées et anonymisées</li>
        </ul>
      </LegalSection>

      <LegalSection title="Sécurité des Données">
        <p>Nous mettons en œuvre des mesures organisationnelles et techniques pour protéger les données personnelles contre l'accès non autorisé, l'altération, la perte et la divulgation illégale. L'accès est limité selon le besoin d'en connaître.</p>
      </LegalSection>

      <LegalSection title="Vos Droits">
        <p>Sous réserve du droit tunisien et des exceptions applicables, vous pouvez demander :</p>
        <ul className="list-disc pl-6 space-y-1.5 mt-2">
          <li>L'accès à vos données personnelles</li>
          <li>La rectification des données inexactes ou incomplètes</li>
          <li>La suppression des données lorsque la loi le permet</li>
          <li>Le retrait du consentement pour les traitements fondés sur le consentement</li>
        </ul>
      </LegalSection>

      <LegalSection title="Cookies et Technologies de Suivi">
        <p>LinxExpress utilise des cookies/traceurs essentiels, analytiques et marketing conformément aux règles applicables. Vous pouvez gérer vos préférences via les paramètres navigateur.</p>
      </LegalSection>

      <LegalSection title="Confidentialité des Enfants">
        <p>LinxExpress est strictement réservé aux utilisateurs de 18 ans et plus. Nous ne traitons pas sciemment de comptes de mineurs.</p>
      </LegalSection>

      <LegalSection title="Modifications">
        <p>Nous pouvons modifier cette Politique de Confidentialité à tout moment. Les modifications prennent effet dès leur publication sur cette page.</p>
      </LegalSection>

      <LegalSection title="Contact">
        <p>Responsable de traitement : AGODEV SOLUTIONS SARL (RNE: B509612026, MF: 1958385L), avenue Habib Bourguiba Teboulbou Gabès 6032, Tunisie. Contact : contact@agodevsolutions.com.</p>
      </LegalSection>
    </LegalLayout>
  );
}
